import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { geti18n } from '../../../utils/StringUtil'
import SieauParameterDto from '../../../administration/dto/SieauParameterDto'
import Checkbox from '../../../components/forms/Checkbox'
import DtoInstallationType from '../../dto/installation/DtoInstallationType'
import Switch from '../../../components/forms/Switch'
import { NewTable } from 'components/datatable/NewTable'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material'

const InstallationsListPanelsOptions = ({
    panels = [],
    onChange = () => {},
    applicationSettings = [],
    installationsTypes = [],
    readMode = true,
}) => {
    const onChangeOption = (option) => {
        if (!readMode) {
            onChange({
                applicationSettings: [
                    ...applicationSettings.filter(as => as.parameter !== option.parameter),
                    new SieauParameterDto({ ...option, value: !option.hide ? 'hidden' : '', isChanged: true }),
                ],
            })
        }
    }

    const onChangePanel = (panel) => {
        onChange({
            installationsTypes: [
                ...installationsTypes.filter(it => it.code !== panel.code),
                new DtoInstallationType({ ...panel, display: !panel.display, isChanged: true }),
            ],
        })
    }

    const getContent = (panel) => {
        if (!panel.display) {
            return []
        }

        const headers = readMode ? ['name'] : ['name', 'display']
        const tableData = panel.components.map(c => ({
            ...c,
            name: geti18n(c.label),
            color: c.hide ? 'grey lighten-1' : 'white',
            display: (
                <Switch
                    checked={ !c.hide }
                    disabled={ readMode }
                    onChange={ () => onChangeOption(c) }
                    freezeOpti={ true }
                />
            ),
        }))
        return (
            <NewTable
                rows={tableData}
                headers={headers}
            />
        )
    }

    const getTitle = (panel) => {
        return (
            <Grid container alignItems='center'>
                {!readMode && (
                    <Checkbox
                        checked={ panel.display }
                        onChange={ () => onChangePanel(panel) }
                        className='white-checkbox'
                        readMode={ readMode }
                    />
                )}
                <Grid size='grow'>
                    <h6>
                        { panel.name }
                        <span className='nbElementsActivated'>
                            { ` (${panel.components.filter(c => !c.hide).length} / ${panel.components.length} ${i18n.elements})` }
                        </span>
                    </h6>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid container spacing={1} direction='column'>
            {panels.map((panel, i) => (
                <Accordion key={i}>
                    <AccordionSummary sx={!panel.display ? { backgroundColor: 'grey' } : {}}>{getTitle(panel)}</AccordionSummary>
                    <AccordionDetails sx={{ padding: 0 }}>
                        {getContent(panel)}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Grid>
    )
}

InstallationsListPanelsOptions.propTypes = {
    panels: PropTypes.shape([]),
    onChange: PropTypes.func,
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    installationsTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationType)),
    readMode: PropTypes.bool,
}

export default InstallationsListPanelsOptions
